<template>
  <div class="px-3 py-3 sm:px-5 w-full bg-white">
    <form @submit.prevent="sendMessage" class="flex items-center gap-3">
      <input
        v-model="message"
        type="text"
        placeholder="Type a message..."
        class="min-w-0 flex-1 border border-gray-200 rounded-full px-5 py-3.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 disabled:bg-gray-50 disabled:text-gray-400"
        :disabled="disabled"
      />
      <button
        type="submit"
        class="h-12 w-12 sm:h-[52px] sm:w-[52px] rounded-full transition-all duration-200 disabled:cursor-not-allowed flex items-center justify-center shrink-0 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        :disabled="!canSend"
        :class="canSend
          ? 'bg-blue-600 text-white shadow-md hover:bg-blue-700 active:scale-95'
          : 'bg-gray-100 text-gray-400'"
        aria-label="Send message"
      >
        <span class="material-symbols-outlined text-2xl">send</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: ''
    };
  },
  computed: {
    canSend() {
      return this.message.trim().length > 0 && !this.disabled;
    }
  },
  methods: {
    sendMessage() {
      if (!this.canSend) return;

      this.$emit('send', this.message.trim());
      this.message = '';
    }
  }
};
</script>
